import React, { useEffect, useState } from "react";
import styles from "./Team.module.css";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Avatar } from "@mui/material";

function Team(props) {
  const { 
    orgData, 
    featuredMembers, 
    teachingInfo 
  } = props;

  const [dataToShow, setDataToShow] = useState([])

  // useEffect(() => {
  //   if(featuredMembers?.length > 0){
  //     const sortedData = [...featuredMembers].sort((a, b) => a.featured_order - b.featured_order);
  //     let tempData = sortedData?.map((singleMember) => {
  //       return {
  //         img: singleMember?.user?.image,
  //         name: `${singleMember?.user?.first_name} ${singleMember?.user?.last_name}`,
  //         designation: singleMember?.designation,
  //         link:"#"
          
  //       }
  //     })
  //     setDataToShow(tempData)
  //   }else{
      
  //     setDataToShow([])
  //   }
  // },[featuredMembers])

  useEffect(() => {

    if(teachingInfo?.teamMembers?.length > 0){
      const sortedData = [...teachingInfo?.teamMembers].sort((a, b) => a.sort - b.sort);
      let tempData = sortedData?.map((singleMember) => {
        return {
          img: singleMember?.profileImageUrl,
          name: singleMember?.name,
          designation: singleMember?.designation,
          link:"#"
          
        }
      })
      setDataToShow(tempData)
    }else{
      
      setDataToShow([])
    }

  },[teachingInfo])


  return (
    <>
      <div className={styles.Container}>
        <div className={styles.BannerContainer}>
          <div className={styles.BannerContainerInner}>
            <div className={styles.Title}>Team</div>

            <div className={styles.CardContainer}>
              {dataToShow.map((item, i) => (
                <div className={styles.TeamCard}>
                  <div className={styles.TeamCardImg}>
                    {/* <img src={item.img} /> */}
                    <Avatar
                      key={i}
                      sx={{ width: 200, height: 200 }}
                      src={item?.img ? item?.img : ""}
                    >
                      {item?.img
                        ? ""
                        : item?.name
                        ? item?.name[0]?.toUpperCase()
                        : ""}
                    </Avatar>
                    
                  </div>
                  <div className={styles.TeamCardDetails}>
                    <h2>{item.name}</h2>
                    {item.designation &&
                    <h3>{item.designation}</h3>
                  }
                    {/* <div className={styles.ViewButton}>
                      <a  href={item.link}>View teacher profile <ArrowForwardIcon /></a>
                    </div> */}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Team;
